import axios from '../../bootstrap';

export function wexBlogList() {
    return axios.get('/api/admin/wex/blog/lists').then(result => result.data);
}

export function wexBlogCategoryList() {
    return axios
        .get('/api/admin/wex/blog/category/lists')
        .then(result => result.data);
}

export function wexBlogCategory() {
    return axios
        .get('/api/admin/wex/blog/category')
        .then(result => result.data);
}

export function wexBlogRecently() {
    return axios
        .get('/api/admin/wex/blog/recently')
        .then(result => result.data);
}
